<template>
  <div class="page-default">
    <div class="is-height-body">
      <div class="p-4 border-bottom border-dark ">
        <div class="row">
          <div class="col-md col-sm-12">
            <button
              class="btn btn-link btn-sm"
              @click="handleBacktoCases"
              data-placement="top"
              @mouseover="helper.showTooltip"
              @mouseleave="helper.hideTooltip"
              title="Back to All Cases"
            >
              <font-awesome-icon
                class="mr-2"
                :icon="['fas', 'angle-left']"
              />Back to All Cases
            </button>
          </div>
          <div class="col-md-6 col-sm-12">
            <div class="custom-file d-flex justify-content-center">
              <div class="input-group input-group is-mx-width-body">
                <div class="custom-file hide-browse">
                  <input
                    type="file"
                    class="custom-file-input input"
                    id="inputGroupFile04"
                    aria-describedby="inputGroupFileAddon04"
                    @change="handleUpload"
                    data-placement="top"
                    @mouseover="helper.showTooltip"
                    @mouseleave="helper.hideTooltip"
                    title="Click to choose file"
                  />
                  <label
                    class="custom-file-label bg-dark-input"
                    for="inputGroupFile04"
                    >{{ fileName ? fileName : "Choose file" }}</label
                  >
                </div>
                <div class="input-group-append" v-if="output == null">
                  <button
                    class="btn btn-primary"
                    type="button"
                    id="inputGroupFileAddon04"
                    @click="handleSubmit"
                    :disabled="isLoading"
                    data-placement="top"
                    @mouseover="helper.showTooltip"
                    @mouseleave="helper.hideTooltip"
                    title="Click to upload"
                  >
                    Upload
                  </button>
                </div>
                <div class="input-group-append" v-else>
                  <button
                    class="btn btn-danger"
                    type="button"
                    id="inputGroupFileAddon04"
                    @click="handleRemove"
                    data-placement="top"
                    @mouseover="helper.showTooltip"
                    @mouseleave="helper.hideTooltip"
                    title="Click to remove"
                  >
                    Clear
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="col"></div>
        </div>
      </div>
      <div
        class="py-4 is-scrollable-content "
        v-if="!isLoading"
      >
        <div class="mx-auto is-content-result">
          <p class="text-light break-word-text" v-if="output != null">
            {{ output }}
          </p>
          <p class="text-muted break-word-text text-center m-4" v-else>
            <font-awesome-icon class="mr-2" :icon="['fas', 'inbox']" />No Data
          </p>
        </div>
        <!-- <div class="mx-auto is-content-result" v-if="output != null">
          <div
            class="text-muted"
            v-for="(text, i) in splitingString(output)"
            :key="i"
            style="font-family: monospace"
          >
            <div :key="i" v-if="text != ''">
              <div>
                <div v-for="(obj, idx) in splittingPoint(text)" :key="idx">
                  <h5 v-if="idx < 1">{{ obj }}</h5>
                  <div v-else class="mb-0">
                    <p v-if="!obj.includes('Image uploaded to:')">-{{ obj }}</p>
                    <div v-else class="mb-3">
                      <p>
                        - image uploaded to:<a
                          class="text-decoration-none"
                          style="color: blue"
                          @click="goTo(getLink(obj))"
                          >{{ getLink(obj) }}</a
                        >
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <hr />
            </div>
          </div>
        </div> -->
      </div>
      <div class="loading-ui" v-if="isLoading">
        <div class="spinner-border spinner-border-sm mr-1"></div>
        <span class="text-muted">Loading ...</span>
      </div>
    </div>
  </div>
</template>
<script>
import Axios from "axios";
import Swal from "sweetalert2";
import Helper from "@/helper";

export default {
  name: "upload",
  data() {
    return {
      isLoading: false,
      output: null,
      file: null,
      fileName: "",
      helper: Helper,
    };
  },
  methods: {
    handleBacktoCases() {
      this.$router.push({
        name: "cases",
      });
    },
    handleRemove() {
      const files = document.getElementById("inputGroupFile04");
      files.value = [];
      this.output = null;
      this.file = null;
      this.fileName = "";
      this.isLoading = false;
    },
    handleUpload() {
      let inputValue = document.getElementById("inputGroupFile04");

      if (inputValue && inputValue.files.length > 0) {
        this.file = inputValue.files;
        this.fileName = inputValue.files[0].name;
      }
    },
    async handleSubmit() {
      const inputValue = document.getElementById("inputGroupFile04");
      const endpoint = "https://infrasel-drone-processing-api.inference.asia/";
      const formData = new FormData();
      if (inputValue && inputValue.files.length > 0) {
        formData.append(`file`, inputValue.files[0]);
        try {
          this.isLoading = true;
          const res = await Axios.post(endpoint, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          });
          if (res.status == 200) {
            this.output = res.data;
            this.isLoading = false;
            // this.splitingString(res.data);
          } else {
            Swal.fire(
              "",
              `${this.fileName.toUpperCase()} file upload failed.`,
              "error"
            );
            this.handleRemove();
          }
        } catch (error) {
          Swal.fire(
            "",
            `${this.fileName.toUpperCase()} file upload failed.`,
            "error"
          );
          this.handleRemove();
        }
      } else {
        Swal.fire("", `File not found`, "error");
      }
    },
    // splitingString(text) {
    //   const splitRow = text.split("========");
    //   return splitRow;
    // },
    // splittingPoint(text) {
    //   const splitRow = text.split("->");
    //   let result = splitRow.join();
    //   return splitRow.length > 1 ? result.split(",") : "";
    // },
    // getLink(text) {
    //   const value = text.split(":");
    //   return `${value[1]}:${value[2]}`;
    // },
    // goTo(link) {
    //   window.open(link);
    // },
  },
};
</script>